import { Routes, Route } from "react-router-dom";

// Public
import PublicLayout from "../layouts/PublicLayout";
import Home from "../pages/public/Home";
import About from "../pages/public/About";
import Facilities from "../pages/public/Facilities";
import TrustTeam from "../pages/public/TrustTeam";
import SchoolTeam from "../pages/public/SchoolTeam";
import Gallery from "../pages/public/Gallery";
import GalleryAlbum from "../pages/public/GalleryAlbum";
import Documents from "../pages/public/Documents";
import ContactUs from "../pages/public/ContactUs";
import DynamicPage from "../pages/public/DynamicPage";
// Admin
import Login from "../pages/admin/Login";
import ProtectedRoute from "../components/common/ProtectedRoute";
import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../pages/admin/Dashboard";
import SettingsPage from "../pages/admin/SettingsPage";
import SlidersPage from "../pages/admin/SlidersPage";
import ContentBlocksPage from "../pages/admin/ContentBlocksPage";
import FacilitiesPage from "../pages/admin/FacilitiesPage";
import TrustTeamPage from "../pages/admin/TrustTeamPage";
import SchoolTeamPage from "../pages/admin/SchoolTeamPage";
import GalleryPage from "../pages/admin/GalleryPage";
import DocumentsPage from "../pages/admin/DocumentsPage";
import NotificationsPage from "../pages/admin/NotificationsPage";
import ContactPage from "../pages/admin/ContactPage";
import EnquiriesPage from "../pages/admin/EnquiriesPage";
import PagesPage from "../pages/admin/PagesPage";
import MenuBuilderPage from "../pages/admin/MenuBuilderPage";

function AppRoutes() {
  return (
    <Routes>
      {/* ===== PUBLIC ===== */}
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="facilities" element={<Facilities />} />
        <Route path="trust-team" element={<TrustTeam />} />
        <Route path="school-team" element={<SchoolTeam />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="gallery/:albumId" element={<GalleryAlbum />} />
        <Route path="documents" element={<Documents />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="pages/:slug" element={<DynamicPage />} />
        {/* gallery, documents, notifications, contact, pages/:slug added next */}
      </Route>

      {/* ===== ADMIN ===== */}
      <Route path="/admin/login" element={<Login />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="sliders" element={<SlidersPage />} />
        <Route path="content" element={<ContentBlocksPage />} />
        <Route path="facilities" element={<FacilitiesPage />} />
        <Route path="trust-team" element={<TrustTeamPage />} />
        <Route path="school-team" element={<SchoolTeamPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="enquiries" element={<EnquiriesPage />} />
        <Route path="pages" element={<PagesPage />} />
        <Route path="menu" element={<MenuBuilderPage />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
